module.exports = __webpack_public_path__ + "static/img/gpt14.92d68f7b.png";